import axios from 'axios';
import { useEffect, useState } from 'react';
import { RoomContext, TrackToggle } from '@livekit/components-react';
import { Room, RoomEvent } from 'livekit-client';
import { useTracks, RoomAudioRenderer } from "@livekit/components-react";
import { VideoTrack } from '@livekit/components-react';
import { Track } from 'livekit-client';
import '@livekit/components-styles';
import { Button, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useTrackToggle } from '@livekit/components-react';
import "bootstrap-icons/font/bootstrap-icons.css";
import { Rnd } from 'react-rnd'
import { useNavigate } from 'react-router-dom';
import Mapping from '../data/mapping.json'

function CityVideoRenderer({ agentName}) {
    const trackRefs = useTracks([Track.Source.Camera]);
    const camTrackRef = trackRefs.find(
        (trackRef) => trackRef.participant.name === agentName
    );
    
    if (!camTrackRef) {
        return (
            <div class="image-wrapper loading">
                <img class="avatar-img"
                    src={process.env.PUBLIC_URL + "/avatar-meera.webp"}
                    alt="preview"
                    onload="this.parentElement.classList.remove('loading')"
                />
                <div class="image-overlay">
                    <img src="/loader2.gif" alt="loading" class="loader-image" />
                </div>
            </div>

        );
    }

    return (
            <div className="video-wrapper position-relative">
                <VideoTrack
                    trackRef={camTrackRef}
                    className='video-el'
                />
                <RoomAudioRenderer />
                {/* <button className="zoom-btn" onClick={() => setIsZoom(true)}><i className="bi bi-arrows-angle-expand fs-4"></i></button> */}
            </div>
        );
}

const PauseButton = ({ variant }) => {

    const { buttonProps, enabled } = useTrackToggle({
        source: Track.Source.Microphone,
        initialState: true
    });

    return (
        <Button variant='dark' onClick={buttonProps.onClick} className={`rounded-circle d-flex align-items-center justify-content-center shadow ${variant ? variant : 'pause-btn'}`}>
            <i className={`bi ${enabled ? "bi-pause-fill" : "bi-play-fill"}`} />
        </Button>
    );
};

function Avatar(props){
       axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
       const [room] = useState(() => new Room({}));
       const [showAvatar, setShowAvatar] = useState(false);
       const [agentName, setAgentName] = useState(null);
       const [roomName, setRoomName] = useState(null);
       const [loading, setLoading] = useState('')
       const [imageLoaded, setImageLoaded] = useState(true);
       const DEFAULT_WIDTH = 380;
       const DEFAULT_HEIGHT = 400;
       const MARGIN = 16;
       const MOBILE_BREAKPOINT = 480;
       const MOBILE_WIDTH = 350;
       const MOBILE_HEIGHT = 260;

        const [size, setSize] = useState({
        width: DEFAULT_WIDTH,
        height: DEFAULT_HEIGHT,
        });

        const [position, setPosition] = useState({
        x: window.innerWidth - DEFAULT_WIDTH - MARGIN,
        y: window.innerHeight - DEFAULT_HEIGHT - MARGIN,
        });
        
        // const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

       // Make the floating window a bit smaller on narrow screens and keep it anchored
       useEffect(() => {
        const applyResponsive = () => {
        const vw = window.innerWidth;
        const vh = window.innerHeight;

        const width =
            vw <= MOBILE_BREAKPOINT
            ? Math.min(MOBILE_WIDTH, vw - MARGIN * 2)
            : DEFAULT_WIDTH;

        const height =
            vw <= MOBILE_BREAKPOINT
            ? Math.min(MOBILE_HEIGHT, vh - MARGIN * 2)
            : DEFAULT_HEIGHT;

        const x = Math.max(MARGIN, vw - width - MARGIN);
        const y = Math.max(MARGIN, vh - height - MARGIN);

        setSize({ width, height });
        setPosition({ x, y });
        };
        applyResponsive();
        window.addEventListener('resize', applyResponsive);
        return () => window.removeEventListener('resize', applyResponsive);
       }, []);
       const navigate = useNavigate();    
       const currentPage = window.location.pathname;
       
       
    //    useEffect(()=>{
    //         connect();
    //     },[])

       const tabToSectionMap={
         "AI":"AI",
         "Services":"Services",
         "Insights":"Artifacts",
         "Technologies":"TechStack",
         "Leaders":"Leadership"
       }

       room.on(RoomEvent.DataReceived, (payload, participant, kind, topic) => {
          
            if (topic==='navigation'){
                const page = new TextDecoder().decode(payload).trim();
                 console.log("Navigating to : ", page)
                
                 if (!page || page.toLowerCase()==="home"){
                     props.setShowWhatWeDo(false)
                     navigate('/')
                 }

                if(page.toLowerCase()==="capabilities"){

                    props.setWhatWeDo('Capabilities')
                    props.setShowWhatWeDo(true)
                    // window.scrollTo(0, 0);
                }
                    
                if(page.toLowerCase()==="industries"){
                     props.setWhatWeDo('Industries')
                     props.setShowWhatWeDo(true)
                     // window.scrollTo(0, 0);
                }

                if(page.startsWith('Capability-')){
                    props.setShowWhatWeDo(false)
                    const capability_name = page.split('-')[1]
                    const tab = page.split('-')[2] 
                    const section = tab ? tabToSectionMap[tab] : 'top'
                    const capability = Mapping.find((capability)=>capability.Desc===capability_name)
                    const shortDesc=capability.ShortDesc
                    if (shortDesc){
                      navigate(`/capabilities/${shortDesc}#${section}`)
                    }   
                    return
                }

                if(page.startsWith('Industry-')){
                    props.setShowWhatWeDo(false)
                    const industry_name = page.split('-')[1]
                    const tab = page.split('-')[2] 
                    const section = tab ? tabToSectionMap[tab] : 'top'
                    const industry = Mapping.find((industry)=>industry.Desc===industry_name)
                    const shortDesc=industry?.ShortDesc
                    if (shortDesc){
                       navigate(`/capabilities/${shortDesc}#${section}`)
                    }
                    return
                }

                if(page==="insights"){
                   props.setShowWhatWeDo(false)
                   navigate('/insights')
                }
                    
                if(page==="careers"){
                   props.setShowWhatWeDo(false)
                   navigate('/careers')
                } 

                if(page.startsWith('Section-')){
                    props.setShowWhatWeDo(false)
                    const tab = page.split('-')[1]
                    const section = tabToSectionMap[tab]
                    if (section)
                        navigate(`${currentPage}#${section}`)
                    return
                }

            }
            return 
        });

       function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min) + min);
    }

       const connect = () => {
        //create room
        const roomName = `testroom-${getRandomInt(1000, 9999)}`;
        setRoomName(roomName);
        const participantName = 'You';
        const agent = process.env.REACT_APP_AGENT_NAME;
        console.log('Agent Name:', agent);
        setAgentName(agent)
        console.log('Room Name:', roomName, 'Participant Name:', participantName);
        createRoom(roomName, participantName);
        //create agent and add to room
        createAgentSession(roomName, agent);
        setShowAvatar(true);
    }

    async function createRoom(roomName, participantName) {
        const result = await axios.get(`/getLivekitToken/${roomName}/${participantName}`)
        console.log('Livekit token', result.data);
        room.connect(process.env.REACT_APP_LIVEKIT_URL, result.data);
    }

    async function createAgentSession(roomName, agent) {
        setLoading('agent-starting');
        console.log('Creating test session for agent:', agent);
        
        try {
            // const result = await axios.post("/start_agent", {agentName:agent, roomName:roomName}, { headers: { "Content-Type": "application/json" } });
            const result = await axios.post("/dispatch_agent", {agentName:agent, roomName:roomName}, { headers: { "Content-Type": "application/json" } });
            console.log('Test agent session start result', result.data);
        }
        catch (error) {
            console.log("Error occurred at creating agent: ", error)
        }
        finally {
            setLoading('')
            console.log("Agent session created.");
        }
    }

    async function stopagentsession() {
        setLoading('agent-stopping');
        setShowAvatar(false);
        try {
            room.disconnect();
            const result = await axios.post("/stop_agent_session", {
                "room_name": roomName
            })
            console.log(result);
        }
        catch (error) {
            console.log("Error occurred during stop agent:", error)
        }
        finally {
            setLoading('')
            console.log("Agent session stopped.");
        }

    }

    return(<>
 
     <RoomContext.Provider data-lk-theme="default" value={room}>
        {showAvatar && <Rnd
            size={size}
            position={position}
            cancel=".control-btn, .controls, .controls *"
                onDragStop={(e, d) => {
                  setPosition({ x: d.x, y: d.y });
                }}
                onResizeStop={(e, direction, ref, delta, pos) => {
                  setSize({
                    width: ref.style.width,
                    height: ref.style.height,
                  });
                  setPosition(pos);
                }}
                // bounds="window"
                className="floating-window">
            <Container
                fluid
                className="agent-container">
                    <div className="video-room">
                    <CityVideoRenderer
                        agentName={agentName}
                    />

                    <div className="controls">
                        <TrackToggle
                        className="control-btn rounded-circle mute-btn"
                        source={Track.Source.Microphone}
                        />

                        <PauseButton />

                        <Button
                        className="control-btn rounded-circle text-light position-relative"
                        variant="danger"
                        onClick={stopagentsession}
                        disabled={loading}>
                        <i className="bi bi-telephone-x-fill fs-6 position-absolute top-50 start-50 translate-middle" />
                        </Button>
                    </div>
                </div>
            </Container>
        </Rnd>
       }
     {!showAvatar && (
        <div className="collapsed-avatar d-flex flex-column align-items-center" style={{position:'fixed', right: MARGIN, bottom: 40, zIndex:9999}}>
            <button
                onClick={connect}
                aria-label="Open assistant"
                className="btn btn-dark rounded-circle d-flex align-items-center justify-content-center shadow"
                style={{width:64, height:64, padding:0}}
            >
            {imageLoaded ? (
                        <img
                            src={process.env.PUBLIC_URL + '/avatar-meera.png'}
                            alt="assistant"
                            onError={(e) => { setImageLoaded(false); e.target.style.display = 'none'; }}
                            onLoad={() => setImageLoaded(true)}
                            style={{width:64, height:64, objectFit:'inherit', borderRadius:'50%'}}
                        />
                    ) : (
                        <i className="bi bi-chat-dots-fill" style={{fontSize:22}} />
                    )}
            </button>
            <button onClick={connect} className="btn border border-white text-white px-3 py-2 rounded mt-2" style={{backgroundColor: '#000000', fontSize:'12px'}}>May I Help?</button>    
        </div>
     )}
     </RoomContext.Provider>

    </>)
}
export default Avatar




